import React, { createContext, useState, useContext } from "react";

// Crear el contexto
const ZonaContext = createContext();

// Hook para usar el contexto fácilmente
export const useZona = () => useContext(ZonaContext);

// Provider
export const ZonaProvider = ({ children }) => {
  // Inicializamos con la zona del localStorage si existe
  const [zonaActiva, setZonaActiva] = useState(localStorage.getItem("zonaActiva") || "");

  const cambiarZona = (zona) => {
    setZonaActiva(zona);
    localStorage.setItem("zonaActiva", zona);
  };

  return (
    <ZonaContext.Provider value={{ zonaActiva, cambiarZona }}>
      {children}
    </ZonaContext.Provider>
  );
};